module.exports = __webpack_public_path__ + "img/qcode.82f833d9.jpg";